module.exports = __webpack_public_path__ + "media/images/sp/reports/main_visual_07-251343db5350f427a8a0a550d905e8b6.jpg";